// extracted by mini-css-extract-plugin
export const socialButton = "social-button-module--social-button--Zxklb";